<style lang="scss">
@import "../styles/payment-v2/payment-menu-info-wrap.scss";
</style>
<template>
  <div class="payment-menu-info-wrap">
    <v-layout v-if="!paymentMethodSelected" row wrap>
      <v-flex xs12 md6 class="form-offset-right">
        <PaymentContentSummary
          :subscription-ids="subscriptionIds"
          :unpaidBillsDetails="unpaidBillsDetails"
          :default-payment-data="defaultPaymentData"
          :one-off-codes="oneOffCodes"
          :request-payment-items="requestPaymentItems"
          :add-shareholder-id="addShareholderId"
          :promo-code-enabled="isPromoCodeEnable"
          :upgrade-corp-sec-subscription="upgradeCorpSecSubscription"
          :company-id-from-billing-profile="companyIdFromBillingProfile"
        />
      </v-flex>
      <v-flex v-if="new_payment_ui_payment_select" xs12 md6 class="payment-menu-info-left-panel new-payment-ui-method">
        <div class="mb-3">
          <div class="title">How would you like to pay?</div>
          <PaymentMethodSelect
            :payment-methods-topic="paymentMethodsTopic"
            :paymentMethodSelected="selected"
            :newUI="new_payment_ui_payment_select"
            @paymentMethodChange="paymentMethodChange"
          />

          <v-layout v-if="viaAccountingOptions" justify-space-between>
            <v-btn outline color="primary" type="button" @click="triggerBackButton">
              <v-icon left>chevron_left</v-icon>
              <span class="text-uppercase">{{ this.$t("$onboarding.card.buttons.back") }}</span>
            </v-btn>

            <v-btn color="primary" type="button" :loading="isButtonLoading" @click="showPaymentForm()">
              <span>{{ this.$t("$accounting.accounting_plans.pay_now") }}</span>
            </v-btn>
          </v-layout>
          <v-card-actions v-else>
            <v-btn :loading="isButtonLoading" class="submit-btn" @click="showPaymentForm()" block color="primary"
              ><span>{{ this.$t("$onboarding.card.buttons.continue_to_payment") }}</span>
            </v-btn>
          </v-card-actions>
        </div>
      </v-flex>
      <v-flex v-if="!new_payment_ui_payment_select" xs6 md6 class="form-offset-right">
        <PaymentMenuContentFormWithUnregisteredCard
          :payment-methods-topic="paymentMethodsTopic"
          :credit-cards="creditCards"
          :default-payment-data="defaultPaymentData"
          :promo-code-enabled="isPromoCodeEnable"
          :platform-config="platformConfig"
          @displayAfterPaymentScreen="displayAfterPaymentScreen"
          @triggerBackButton="triggerBackButton"
          :subscription-ids="subscriptionIds"
          :task="task"
          :one-off-codes="oneOffCodes"
          :request-payment-id="requestPaymentId"
          :request-payment-items="requestPaymentItems"
          :add-shareholder-id="addShareholderId"
          :accountingSetupOptions="accountingSetupOptions"
          :updateQuestionnaireMultiCurrency="updateQuestionnaireMultiCurrency"
          :is-partner-billing-profile-payment="isPartnerBillingProfilePayment"
          :company-id-from-billing-profile="companyIdFromBillingProfile"
          :upgrade-corp-sec-subscription="upgradeCorpSecSubscription"
          :is-renewal-payment="true"
          :unpaidBillsDetails="unpaidBillsDetails"
        />
        <PaymentMenuContentFormWithRegisteredCard
          :payment-methods-topic="paymentMethodsTopic"
          :credit-cards="creditCards"
          :default-payment-data="defaultPaymentData"
          :promo-code-enabled="isPromoCodeEnable"
          :subscription-ids="subscriptionIds"
          :platform-config="platformConfig"
          @displayAfterPaymentScreen="displayAfterPaymentScreen"
          @triggerBackButton="triggerBackButton"
          :task="task"
          :one-off-codes="oneOffCodes"
          :request-payment-id="requestPaymentId"
          :request-payment-items="requestPaymentItems"
          :add-shareholder-id="addShareholderId"
          :accountingSetupOptions="accountingSetupOptions"
          :updateQuestionnaireMultiCurrency="updateQuestionnaireMultiCurrency"
          :is-partner-billing-profile-payment="isPartnerBillingProfilePayment"
          :company-id-from-billing-profile="companyIdFromBillingProfile"
          :upgrade-corp-sec-subscription="upgradeCorpSecSubscription"
          :is-renewal-payment="true"
          :unpaidBillsDetails="unpaidBillsDetails"
        />
        <PaymentMenuContentFormBankTransfer
          :payment-methods-topic="paymentMethodsTopic"
          :default-payment-data="defaultPaymentData"
          :promo-code-enabled="isPromoCodeEnable"
          :subscription-ids="subscriptionIds"
          :platform-config="platformConfig"
          @displayAfterPaymentScreen="displayAfterPaymentScreen"
          @triggerBackButton="triggerBackButton"
          :task="task"
          :one-off-codes="oneOffCodes"
          :request-payment-id="requestPaymentId"
          :request-payment-items="requestPaymentItems"
          :add-shareholder-id="addShareholderId"
          :accountingSetupOptions="accountingSetupOptions"
          :updateQuestionnaireMultiCurrency="updateQuestionnaireMultiCurrency"
          :is-partner-billing-profile-payment="isPartnerBillingProfilePayment"
          :company-id-from-billing-profile="companyIdFromBillingProfile"
          :upgrade-corp-sec-subscription="upgradeCorpSecSubscription"
          :is-renewal-payment="true"
          :unpaidBillsDetails="unpaidBillsDetails"
        />
      </v-flex>
    </v-layout>

    <v-layout v-if="paymentMethodSelected" row wrap>
      <v-flex xs12 md12 class="form-offset-right">
        <PaymentFormWithRegisteredCard
          :payment-methods-topic="paymentMethodsTopic"
          :credit-cards="creditCards"
          :payment-method-selected="paymentMethodSelected"
          :default-payment-data="defaultPaymentData"
          :promo-code-enabled="isPromoCodeEnable"
          :platform-config="platformConfig"
          :shopping-cart-total="shoppingCartTotal"
          :subscription-ids="subscriptionIds"
          :task="task"
          :one-off-codes="oneOffCodes"
          :request-payment-id="requestPaymentId"
          :request-payment-items="requestPaymentItems"
          :add-shareholder-id="addShareholderId"
          :accountingSetupOptions="accountingSetupOptions"
          :updateQuestionnaireMultiCurrency="updateQuestionnaireMultiCurrency"
          :is-partner-billing-profile-payment="isPartnerBillingProfilePayment"
          :company-id-from-billing-profile="companyIdFromBillingProfile"
          :upgrade-corp-sec-subscription="upgradeCorpSecSubscription"
          @displayAfterPaymentScreen="displayAfterPaymentScreen"
          :entryPoint="entryPoint"
          :unpaidBillsDetails="unpaidBillsDetails"
        />
        <PaymentFormWithUnregisteredCard
          :payment-methods-topic="paymentMethodsTopic"
          :credit-cards="creditCards"
          :default-payment-data="defaultPaymentData"
          :payment-method-selected="paymentMethodSelected"
          :shopping-cart-total="shoppingCartTotal"
          :promo-code-enabled="isPromoCodeEnable"
          :platform-config="platformConfig"
          @displayAfterPaymentScreen="displayAfterPaymentScreen"
          :subscription-ids="subscriptionIds"
          :task="task"
          :one-off-codes="oneOffCodes"
          :request-payment-id="requestPaymentId"
          :request-payment-items="requestPaymentItems"
          :accountingSetupOptions="accountingSetupOptions"
          :updateQuestionnaireMultiCurrency="updateQuestionnaireMultiCurrency"
          :is-partner-billing-profile-payment="isPartnerBillingProfilePayment"
          :company-id-from-billing-profile="companyIdFromBillingProfile"
          :upgrade-corp-sec-subscription="upgradeCorpSecSubscription"
          :entryPoint="entryPoint"
          :unpaidBillsDetails="unpaidBillsDetails"
        />
        <PaymentFormBankTransfer
          :invoice="invoice"
          :shoppingCartTotal="shoppingCartTotal"
          :platform-config="platformConfig"
          :payment-methods-topic="paymentMethodsTopic"
          :default-payment-data="defaultPaymentData"
          :promo-code-enabled="isPromoCodeEnable"
          :payment-method-selected="paymentMethodSelected"
          :subscription-ids="subscriptionIds"
          :task="task"
          :one-off-codes="oneOffCodes"
          :request-payment-id="requestPaymentId"
          :request-payment-items="requestPaymentItems"
          :add-shareholder-id="addShareholderId"
          :accountingSetupOptions="accountingSetupOptions"
          :updateQuestionnaireMultiCurrency="updateQuestionnaireMultiCurrency"
          :is-partner-billing-profile-payment="isPartnerBillingProfilePayment"
          @displayAfterPaymentScreen="displayAfterPaymentScreen"
          @getInv="getInv"
          :upgrade-corp-sec-subscription="upgradeCorpSecSubscription"
          :entryPoint="entryPoint"
          :unpaidBillsDetails="unpaidBillsDetails"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from "moment";
import ApplyForManualPaymentProxy from "@/proxies/back-end/manual-payment/apply-for-external-payment";
import GetInvoices from "@/proxies/back-end/invoices/get";
import UpdateInvoiceProxy from "@/proxies/back-end/invoices/update";
import CreateInvoiceProxy from "@/proxies/back-end/invoices/create";
import PaymentContentSummary from "./PaymentContentSummary.vue";
import PaymentMethodSelect from "./PaymentMethodSelect.vue";
import PaymentFormWithRegisteredCard from "@shared-components/presentational/payment-v2/PaymentFormWithRegisteredCard.vue";
import PaymentFormWithUnregisteredCard from "@shared-components/presentational/payment-v2/PaymentFormWithUnregisteredCard.vue";
import PaymentFormBankTransfer from "@shared-components/presentational/payment-v2/PaymentFormBankTransfer.vue";
import PaymentMenuContentFormWithRegisteredCard from "@shared-components/presentational/payment-v2/PaymentMenuContentFormWithRegisteredCard.vue";
import PaymentMenuContentFormWithUnregisteredCard from "@shared-components/presentational/payment-v2/PaymentMenuContentFormWithUnregisteredCard.vue";
import PaymentMenuContentFormBankTransfer from "@shared-components/presentational/payment-v2/PaymentMenuContentFormBankTransfer.vue";
import ShoppingCartManager from "@/utilities/shopping-cart-manager";
import { getAppFeatureProp } from "@/utilities/app-feature-util";
import { isEmpty, get } from "lodash";
import { ConfigMixin } from "@/mixins/config-mixin";
// Utilities
import LocalStoreManager from "@/utilities/local-store-manager";
import GetPaymentRequestByTokenProxy from "@/proxies/back-end/payment-request/get";
import { Constants } from "customer-sdk/constants";
const SHOPPING_CART_EVENTS = Constants.SHOPPING_CART_EVENTS;
const BILLING_EVENTS = Constants.BILLING_EVENTS;
const PAYMENT_ENTRY_POINTS = Constants.PAYMENT_ENTRY_POINTS;

const store = new LocalStoreManager();

const allowedInvoiceUpdate = [PAYMENT_ENTRY_POINTS.ONBOARDING, PAYMENT_ENTRY_POINTS.MANUAL_RENEWAL];
let handleGlobalTopics = component => {
  console.log("LISTENER FIRED!!");
  ShoppingCartManager.addListener(async msg => {
    if (msg.type === SHOPPING_CART_EVENTS.ON_SHOPPING_CART_ITEMS_CHANGED) {
      let msgData = msg && msg.data;
      if (msgData) {
        component.isValidToEnableCheckout = msgData.isValidToEnableCheckout;
      }
      await fetchShoppingCartDetails(component);
    } else if (msg.type === SHOPPING_CART_EVENTS.ON_COMPANY_CHANGED) {
      await fetchShoppingCartDetails(component);
    } else if (msg.type === BILLING_EVENTS.ON_RENDER_PAYMENT_PAGE) {
      component.subscriptionIds = msg.data && msg.data.subscriptionIds ? msg.data.subscriptionIds : [];
      await fetchShoppingCartDetails(component);
    }
  });
};

const setEntryPoint = component => {
  /*
   * Payment request has no action source from the UI
   * so we identify by the url pathname and search field
   * of the current page. We also add the requestPaymentId
   * to identify each payment request
   */
  // Check if this is a payment request page
  if (window.location.pathname === "/payment-request" && window.location.search.includes("?authToken=")) {
    store.setPaymentEntryPoint(`${PAYMENT_ENTRY_POINTS.PAYMENT_REQUEST} - ${component.requestPaymentId}`);
  } else if (
    /*
     * Request has multiplple entrypoints
     * so we identify the url pathname and search field
     * of the current page
     */
    window.location.pathname === "/amend-company-share-structure" ||
    window.location.pathname === "/appointment-of-director-v2/" ||
    window.location.pathname === "/change-of-director-v2/" ||
    window.location.pathname === "/change-of-address/"
  ) {
    store.setPaymentEntryPoint(`${PAYMENT_ENTRY_POINTS.REQUEST} - ${window.location.pathname.replace(/\//g, "")}`);
  }

  component.entryPoint = store.getPaymentEntryPoint();
};

// eslint-disable-next-line max-lines-per-function
let fetchShoppingCartDetails = async component => {
  let cart = new ShoppingCartManager();
  let response = null;

  if (component.upgradeCorpSecSubscription === true) {
    const corpSecSubscriptionDetails =
      component.$store.getters["amendCompanyShareStructureStoreModule/corpSecSubscriptionDetails"];

    const { new_item, current_item, payment_details } = corpSecSubscriptionDetails;
    component.shoppingCart = [
      {
        description: new_item.name,
        amount: payment_details.new_item_amount,
        code: new_item.xero_code,
        isIncludedOnAccountingPlan: false,
        isNewSubscription: true
      },
      {
        description: payment_details.refund_item.name,
        amount: payment_details.refund_amount,
        code: payment_details.refund_item.xero_code,
        serviceDate: getServiceDates(current_item),
        isIncludedOnAccountingPlan: false
      }
    ];
    component.shoppingCartSubTotal = payment_details.total_amount_due;
    component.shoppingCartTotal = payment_details.total_amount_due;
  } else if (!isEmpty(component.unpaidBillsDetails)) {
    let uBillTotalAmount = 0;
    component.unpaidBillsDetails.map(uBill => {
      uBillTotalAmount += uBill.amount;
      component.shoppingCart.push({
        description: uBill.description,
        subDescription: uBill.service_description,
        amount: uBill.amount,
        quantity: 1,
        code: uBill.xero_code
      });
    });
    component.shoppingCartSubTotal = uBillTotalAmount;
    component.shoppingCartTotal = uBillTotalAmount;
  } else {
    let response = await cart.fetchShoppingCartDetails(
      component.subscriptionIds,
      component.oneOffCodes,
      null,
      component.companyIdFromBillingProfile
    );
    if (response && response.shoppingCartTotal !== undefined) {
      component.shoppingCart = response.shoppingCart;
      component.shoppingCartSubTotal = response.shoppingCartSubTotal;
      component.shoppingCartDiscount = response.shoppingCartDiscount;
      component.shoppingCartTotal = response.shoppingCartTotal;
    } else {
      component.hasErrorOnCart = true;
    }
  }

  if (response) {
    component.shoppingCart = response.shoppingCart;
    component.shoppingCartTotal = response.shoppingCartTotal;
  }
};
//#endregion

let getServiceDates = item => {
  let serviceName = "";
  if (item.subscription_date_from && item.subscription_date_to) {
    let formattedDateFrom = moment(item.subscription_date_from).format("DD-MM-YYYY");
    let formattedDateTo = moment(item.subscription_date_to).format("DD-MM-YYYY");
    serviceName = `From: ${formattedDateFrom}, To: ${formattedDateTo}`;
  } else if (item.subscription_date_from) {
    let formattedDateFrom = moment(item.subscription_date_from).format("DD-MM-YYYY");
    serviceName = `From: ${formattedDateFrom}`;
  } else if (item.subscription_date_to) {
    let formattedDateTo = moment(item.subscription_date_to).format("DD-MM-YYYY");
    serviceName = `To: ${formattedDateTo}`;
  } else if (item.start_date && item.end_date) {
    let formattedDateFrom = moment(item.start_date).format("D MMM YYYY");
    let formattedDateTo = moment(item.end_date).format("D MMM YYYY");
    serviceName = `${formattedDateFrom} to ${formattedDateTo}`;
  }
  return serviceName;
};

const getPaymentData = async component => {
  const paymentData = JSON.parse(JSON.stringify(component.defaultPaymentData));
  const paymentAuthToken = component.$route.query.authToken;
  //get company id from payment request instead of current company
  //this piece of if below is created to resolve problem:
  //admin create payment request for company A
  //user currently login to company B and make a payment for company A
  if (paymentAuthToken) {
    const proxy = new GetPaymentRequestByTokenProxy();
    const input = {
      token: paymentAuthToken,
      authToken: component.defaultPaymentData.authToken,
      loggedInUser: store.getUserId()
    };
    const data = await proxy.get(input);
    paymentData.id = data.company._id;
  }

  return paymentData;
};

const handleCreateOrUpdateInvoice = async component => {
  try {
    let proxy = null;

    const { hasItems, items, oneOffCodes, total_number_of_shareholder } = setInvoiceEndpointCreation(component);

    const paymentData = await getPaymentData(component);

    if (!component.invoice) {
      proxy = hasItems ? new CreateInvoiceProxy() : new ApplyForManualPaymentProxy();
      component.invoice = await proxy.execute(paymentData, {
        expected_pay_at: "",
        cheque_number: "",
        invoice_only: false,
        items,
        oneOffCodes,
        invoice_tag: component.entryPoint,
        total_number_of_shareholder
      });
    } else {
      if (!allowedInvoiceUpdate.includes(component.entryPoint)) return;

      proxy = new UpdateInvoiceProxy();
      component.invoice = await proxy.execute(paymentData, {
        payment_method: component.selected,
        items,
        oneOffCodes,
        invoice_tag: component.entryPoint
      });
    }
  } catch (error) {
    throw error;
  }
};

const setInvoiceEndpointCreation = component => {
  let hasItems = false;
  let items = [];
  let oneOffCodes = [];
  let total_number_of_shareholder = 0;
  if (component.subscriptionIds && component.subscriptionIds.length > 0) {
    hasItems = true;
    items = component.subscriptionIds;
  } else if (component.unpaidBillsDetails && component.unpaidBillsDetails.length > 0) {
    hasItems = true;
    items = component.unpaidBillsDetails;
  } else if (
    (component.requestPaymentItems && component.requestPaymentItems.length > 0) ||
    (component.oneOffCodes && component.oneOffCodes.length > 0)
  ) {
    hasItems = true;
    oneOffCodes = component.oneOffCodes;
    items = component.requestPaymentItems;
  } else if (component.upgradeCorpSecSubscription) {
    hasItems = true;
    total_number_of_shareholder = getTotalNumberOfShareHolder(component);
  }
  return { hasItems, items, oneOffCodes, total_number_of_shareholder };
};

const getInvoice = async (component, status) => {
  if (component.unpaidBillsDetails && component.unpaidBillsDetails.length > 0) {
    component.invoice = {
      number: component.unpaidBillsDetails[0].invoice
    };
  } else {
    const proxy = new GetInvoices();
    const paymentData = await getPaymentData(component);
    component.invoice = await proxy.getCompanyInvoice(paymentData, {
      invoice_tag: component.entryPoint,
      status: status
    });
  }
};

const getTotalNumberOfShareHolder = component => {
  const amendCompanyShareStructureData = localStorage.getItem(
    `amendCompanyShareStructureData_${component.defaultPaymentData.id}`
  );
  const shareholders = get(JSON.parse(amendCompanyShareStructureData), "shareholders", []);
  return shareholders.filter(shareholder => !shareholder.is_removed).length;
};

const checkSelectUI = async component => {
  const isPartner = await store.getPartnerId();
  const new_payment_ui_payment_select = getAppFeatureProp(
    component.platformConfig.cmsAppFeatures,
    "new_payment_ui_payment_select"
  );
  if (window.location.pathname === "/change-of-director-v2/") {
    component.new_payment_ui_payment_select = false;
  } else {
    component.new_payment_ui_payment_select =
      new_payment_ui_payment_select.enabled && (!isPartner || isPartner == "null");
  }
};

const setPromoCode = component => {
  if (window.location.pathname === "/payment-request") {
    const promo_code_manual_payment = getAppFeatureProp(component.platformConfig.cmsAppFeatures,"promo_code_manual_payment");
    component.isPromoCodeEnable = get(promo_code_manual_payment, "enabled", false);
  } else if(window.location.pathname === "/billings-and-subscriptions/") {
    component.isPromoCodeEnable = false;
  } else {
    component.isPromoCodeEnable = true;
  }
}

export default {
  components: {
    PaymentContentSummary,
    PaymentMethodSelect,
    PaymentFormWithUnregisteredCard,
    PaymentFormWithRegisteredCard,
    PaymentFormBankTransfer,
    PaymentMenuContentFormWithRegisteredCard,
    PaymentMenuContentFormWithUnregisteredCard,
    PaymentMenuContentFormBankTransfer
  },
  mixins: [ConfigMixin],
  props: {
    paymentMethodsTopic: Object,
    defaultPaymentData: Object,
    subscriptionIds: Array,
    oneOffCodes: Array,
    requestPaymentItems: Array,
    unpaidBillsDetails: Array,
    addShareholderId: String,
    promoCodeEnabled: Boolean,
    upgradeCorpSecSubscription: { type: Boolean, default: false },
    companyIdFromBillingProfile: String,
    creditCards: Array,
    task: Object,
    requestPaymentId: String,
    accountingSetupOptions: Object,
    updateQuestionnaireMultiCurrency: Function,
    isPartnerBillingProfilePayment: {
      type: Boolean,
      default: false
    },
    paymentMethodSelected: String,
    viaAccountingOptions: Boolean
  },
  data() {
    return {
      selected: "add_card",
      shoppingCart: [],
      shoppingCartTotal: 0,
      isButtonLoading: false,
      invoice: null,
      new_payment_ui_payment_select: false,
      item_changed: false,
      entryPoint: PAYMENT_ENTRY_POINTS.ONBOARDING,
      isPromoCodeEnable: false
    };
  },
  methods: {
    paymentMethodChange: function(selected) {
      this.selected = selected;
    },
    showPaymentForm: async function() {
      this.isButtonLoading = true;
      switch (this.selected) {
        case "add_card":
          this.$emit("setPaymentMethodSelected", this.selected);
          this.$emit("setTitle", "Pay with your card");
          this.isButtonLoading = false;
          break;
        case "bank_transfer":
          await handleCreateOrUpdateInvoice(this);
          this.$emit("setPaymentMethodSelected", this.selected);
          this.$emit("setTitle", "Pay with bank transfer");
          this.isButtonLoading = false;
          break;
        case "pay_now":
          await handleCreateOrUpdateInvoice(this);
          this.$emit("setPaymentMethodSelected", this.selected);
          this.$emit("setTitle", "Pay with PayNow");
          this.isButtonLoading = false;
          break;
      }
    },
    getInv: async function(status) {
      console.log("===================", status);
      await getInvoice(this, status);
    },
    displayAfterPaymentScreen: function(obj) {
      this.$emit("displayAfterPaymentScreen", obj);
    },
    triggerBackButton() {
      this.$emit("triggerBackButton");
    }
  },
  async mounted() {
    const component = this;
    setEntryPoint(component);
    handleGlobalTopics(component);
    fetchShoppingCartDetails(component);
    setPromoCode(component);
    await checkSelectUI(component);
    await getInvoice(component, "processsing");
  }
};
</script>